module.exports = __webpack_public_path__ + "img/space-station-moon.3be34017.svg";